import { theme } from '@Guidelines/Theme/theme';
import type FactEvidenceView from '@UI/Store/Documents/Views/FactEvidenceView';
import { css } from '@emotion/react';
import type * as React from 'react';
import Eyebrow from '@Guidelines/Component/Eyebrow';

const cardStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 1rem 1.125rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
`;

const labelStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkMuted};
`;

const valueStyle = css`
	margin: 0;
	font-family: ${theme.fonts.display};
	font-size: ${theme.fontSizes.large};
	color: ${theme.colors.ink};
`;

type Props = {
	readonly evidence: FactEvidenceView;
};

/** One record fact: "Donnée du dossier", the fact's own label and value, and the reminder that a
 * spoken source always outranks it. */
const FactEvidenceCard: React.FC<Props> = ({ evidence }) => (
	<div css={cardStyle}>
		<Eyebrow>Donnée du dossier</Eyebrow>
		<p css={labelStyle}>{evidence.label}</p>
		<p css={valueStyle}>{evidence.value}</p>
	</div>
);

export default FactEvidenceCard;
